import { palette } from './palette';

export const homeStyle = {
  '.drawer-wrapper': {
    '& .drawer-title-container, .drawer-close-button': {
      color: palette.text.highlight,
    },
  },
  '.custom-drawer-wrapper:has(.checkout_stripe_payment) .drawer-title-container': {
    background: `${palette.background.dark} !important`,
    backgroundColor: `${palette.background.dark} !important`,
    color: `${palette.text.highlight} !important`,
    '& .drawer-title, & .drawer-close-button': {
      color: `${palette.text.highlight} !important`,
    },
  },
  '.popup-action-button': {
    color: palette.primary.contrastText,
  },

  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .logo-image': {
        height: 46,
      },

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.accordion__collapsable-text': {
    '& .accordion__collapsable-text_anchor': {
      textDecoration: 'none',
    },
    '& .accordion__collapsable-text_code': {
      textDecoration: 'underline',
    },
    '& .accordion__collapsable-text_number': {
      textDecoration: 'underline',
    },
  },

  '.austininstitutedentalmedicine-container': {
    '& .home-hero-title': {
      color: palette.text.primary,
      fontWeight: '500',
    },
    '& .highlight-text': {
      fontWeight: 'bold',
      color: palette.text.headerhighlight,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.text.highlight,
      overflow: 'hidden',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 120,
        backgroundColor: palette.text.highlight,
        backgroundImage: 'none',
        clipPath:
          'polygon(0 0, 8% 12%, 18% 24%, 30% 34%, 42% 42%, 50% 45%, 58% 42%, 70% 34%, 82% 24%, 92% 12%, 100% 0, 100% 100%, 0 100%)',
        pointerEvents: 'none',
        zIndex: 1,
      },

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
        position: 'relative',
        zIndex: 2,
        '@media screen and (max-width: 1024px)': {
          justifyContent: 'center',
          textAlign: 'center !important',
        },
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
          '@media screen and (max-width: 1024px)': {
            justifyContent: 'center',
            textAlign: 'center !important',
          },
        },
        '& .section-header__title, & .section-header__subtitle': {
          '@media screen and (max-width: 1024px)': {
            textAlign: 'center !important',
          },
        },
        '& .section-header__cta-wrapper': {
          '@media screen and (max-width: 1024px)': {
            display: 'flex',
            justifyContent: 'center !important',
            margin: '0 auto !important',
          },
        },
        '& .section-header__cta-container': {
          '@media screen and (max-width: 1024px)': {
            justifyContent: 'center !important',
          },
        },
      },
      '& .home-hero-subtitle': {
        color: palette.text.primary,
        maxWidth: 510,
        '@media screen and (max-width: 1024px)': {
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
      '& .hero-link-button': {
        backgroundColor: palette.primary.main,
        color: palette.primary.contrastText,
      },
      '& .login-button': {
        backgroundColor: palette.secondary.main,
        color: palette.secondary.contrastText,
        borderColor: palette.secondary.main,
      },
      '& .image-wrapper': {
        position: 'relative',
        overflow: 'hidden',
        '@media(max-width: 900px)': {
          backgroundImage: `linear-gradient(90deg, ${palette.text.highlight} 16%, ${palette.primary.light} 0%)`,
          padding: '24px 48px 24px 16px',
        },
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      background: palette.background.default,
      padding: '56px 80px 80px !important',

      '@media(max-width: 900px)': {
        padding: '56px 24px 80px !important',
      },

      '& .section-alternate': {
        width: '66.6667vw',
        maxWidth: 1280,
        padding: 0,

        '@media(max-width: 900px)': {
          width: '100%',
        },
      },

      '& .section-alternate__content': {
        padding: '0 !important',
      },

      '& .benefits-wrapper': {
        display: 'flex',
        flexDirection: 'column',
        gap: 56,
      },

      '& .section-header': {
        width: '100%',
        margin: '0 !important',

        '@media(min-width: 900px)': {
          paddingBottom: 0,
        },
      },

      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },

      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 500,
        lineHeight: '56px',
        letterSpacing: '-1.92px',
        textAlign: 'left',
      },

      '& .definition-benefits-grid': {
        justifyContent: 'space-between',
        margin: '0 !important',
        width: '100%',

        '@media(min-width: 900px)': {
          flexWrap: 'nowrap',
        },
      },

      '& .definition-service-innertile': {
        height: '100%',
      },

      '& .definition-service-title': {
        color: palette.text.primary,
        fontSize: 24,
        fontWeight: 500,
        lineHeight: '28px',
        letterSpacing: '-0.96px',
      },

      '& .definition-service-description': {
        color: palette.text.description,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '-0.64px',
        paddingBottom: '0 !important',
        borderBottom: '0 !important',
      },

      '& .definition-service-tile': {
        maxWidth: 380,
        padding: '0 0 32px !important',
        flexBasis: '29.6875%',
        borderBottom: `1px solid ${palette.background.cardBorder}`,

        '@media(max-width: 900px)': {
          maxWidth: '100%',
          flexBasis: '100%',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.pricing,
      overflow: 'hidden',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 456,
        height: 120,
        backgroundColor: palette.background.pricing,
        backgroundImage: 'none',
        clipPath:
          'polygon(0 0, 8% 12%, 18% 24%, 30% 34%, 42% 42%, 50% 45%, 58% 42%, 70% 34%, 82% 24%, 92% 12%, 100% 0, 100% 100%, 0 100%)',
        pointerEvents: 'none',
        zIndex: 1,
      },

      '& .subscription-bg': {
        position: 'unset',
        height: 576,
        background: `url('./images/home-images/pricing-benefits.webp') no-repeat center`,
        backgroundSize: 'cover',
      },
      '& #pricing-benefit-section': {
        position: 'relative',
        zIndex: 2,

        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
          backgroundColor: palette.text.alternate,
          border: `1px solid ${palette.text.highlight}`,
        },

        '& .subscription-section': {
          '& .select-plan-button': {
            background: palette.text.highlight,
            color: palette.text.primary,
          },
          '& .section-header': {
            '& .section-header__title, & .section-header__subtitle': {
              color: palette.text.highlight,
            },

            '& .react-multi-carousel-dot-list': {
              display: 'none',
            },
            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .summary-text': {
            color: palette.text.highlight,
            fontWeight: 'normal',
          },
          '& .summary-subtext': {
            color: palette.text.highlight,
            margin: '0 auto',
          },
        },

        '& .planCard': {
          color: palette.text.primary,

          '& .MuiButton-root': {
            width: '100% !important',
            minWidth: '0 !important',
            marginLeft: '0 !important',
            padding: '12px 16px',
            border: '0 !important',
            borderRadius: '16px 0 16px 0',
            background: palette.background.default,
            boxShadow: 'none',
            color: palette.text.primary,
            fontSize: 16,
            lineHeight: '20px',
            letterSpacing: '-0.32px',
          },

          '& .customButtonWrapper': {
            width: '100%',
            margin: '0 !important',
          },

          '& .customButtonWrapper > .MuiGrid-item': {
            flexBasis: '100%',
            maxWidth: '100%',
            padding: '0 !important',
            width: '100%',
          },

          '& .highlight-button': {
            background: `${palette.background.selectedtab} !important`,
            color: `${palette.primary.contrastText} !important`,
          },
        },
        '& .planCard:hover': {
          '& .MuiButton-root': {
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.default,
      overflow: 'hidden',
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        height: 120,
        backgroundColor: palette.background.pricing,
        backgroundImage: 'none',
        clipPath:
          'polygon(0 0, 100% 0, 100% 52%, 92% 42%, 82% 30%, 70% 20%, 58% 12%, 50% 10%, 42% 12%, 30% 20%, 18% 30%, 8% 42%, 0 52%)',
        pointerEvents: 'none',
        zIndex: 1,
      },

      '& .step-counter': {
        width: 40,
        height: 40,
        background: palette.primary.main,
        color: palette.primary.contrastText,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.28px',
      },
      '& .section': {
        maxWidth: 1440,
        padding: '160px 80px 96px !important',
        borderBottom: 0,
        position: 'relative',
        zIndex: 2,

        '@media(max-width: 900px)': {
          padding: '140px 24px 64px !important',
        },
      },
      '& .howitworks-wrapper': {
        padding: '0 !important',

        '& .howitworks-grid': {
          gap: 144,
          justifyContent: 'center',

          '@media(max-width: 1440px)': {
            gap: 48,
          },

          '@media(max-width: 1200px)': {
            gap: 40,
          },

          '@media(max-width: 900px)': {
            gap: 40,
          },
        },

        '& .howitworks-wrapper-left': {
          maxWidth: 533,
          flexBasis: 533,

          '@media(max-width: 900px)': {
            maxWidth: '100%',
            flexBasis: '100%',
          },
        },

        '& .cover-image-wrapper': {
          maxWidth: 600,
          flexBasis: 600,

          '@media(max-width: 1440px)': {
            maxWidth: 500,
            flexBasis: 500,
          },

          '@media(max-width: 900px)': {
            maxWidth: '100%',
            flexBasis: '100%',
          },
        },

        '& .how-cover-image': {
          width: 600,
          height: 600,
          borderRadius: 24,
          objectFit: 'cover',

          '@media(max-width: 1440px)': {
            width: 500,
            height: 500,
          },

          '@media(max-width: 900px)': {
            width: '100%',
            height: 'auto',
          },
        },
      },
      '& .howitworks-title': {
        marginBottom: 64,
      },
      '& .section-header': {
        marginBottom: 0,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 500,
        lineHeight: '56px',
        letterSpacing: '-1.92px',
        textAlign: 'left',
      },
      '& .section-header__subtitle': {
        color: palette.text.description,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '26px',
        letterSpacing: '-0.4px',
        textAlign: 'left',
      },
      '& .working-steps-main-container': {
        padding: '0 !important',
      },
      '& .working-steps-container': {
        gap: 24,
        margin: '0 !important',
        padding: '0 0 32px !important',
        borderBottom: `1px solid ${palette.background.cardBorder}`,
      },
      '& .working-steps-container:not(:first-child)': {
        marginTop: '32px !important',
      },
      '& .step-title': {
        color: palette.text.primary,
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.8px',
        marginBottom: 10,
      },
      '& .step-content': {
        maxWidth: 469,
        color: palette.text.subtle,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '-0.64px',
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      paddingBottom: 80,
      '& .section-alternate': {
        borderBottom: `1px solid ${palette.text.disabled}`,
      },

      '& .section-header__overline-wrapper': {
        color: palette.text.alternate,
      },

      '& .testimonial-title-wrapper': {
        '& .section-header__title': {
          maxWidth: 500,
        },
      },
      '& .testimonial-container': {
        flexDirection: 'column-reverse',

        '@media(min-width: 900px)': {
          flexDirection: 'row-reverse',
        },
      },
      '& .testimonial-content-wrapper': {
        marginTop: 10,
        '@media(min-width: 900px)': {
          marginTop: -200,
        },

        '& .react-multi-carousel-track': {
          paddingTop: 60,
          '@media(min-width: 900px)': {
            paddingTop: 200,
          },
        },
        '& .custom-arrow': {
          border: 0,
          backgroundColor: 'unset',
          top: 0,
          width: 40,
          height: 40,
        },
        '& .left-arrow': {
          right: 75,
          left: 'unset',
        },
        '& .testimonial-message': {
          color: palette.text.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: 400,
        },
      },
      '& .image-wrapper': {
        display: 'flex',
        justifyContent: 'center',

        '@media(min-width: 900px)': {
          justifyContent: 'left',
        },

        '& .image': {
          height: '100%',
          width: 'auto',

          '@media(min-width: 900px)': {
            height: 414,
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      background: palette.background.greySubtle,
      paddingBottom: 0,

      '& .hero-static-bg': {
        backgroundColor: palette.background.greySubtle,
      },
      '& .hero-static-section': {
        maxWidth: 1440,
        backgroundColor: palette.background.greySubtle,

        '@media(max-width: 900px)': {
          margin: 0,
        },

        '& .section-alternate__content': {
          padding: '48px 80px !important',

          '@media(max-width: 900px)': {
            padding: '40px 24px !important',
          },
        },

        '& .hero-button-wrapper': {
          justifyContent: 'flex-end',

          '@media(max-width: 900px)': {
            justifyContent: 'flex-start',
          },
        },

        '& .section-header__title': {
          color: palette.text.primary,
          maxWidth: '100%',
          fontSize: 36,
          fontWeight: 500,
          lineHeight: '40px',
          letterSpacing: '-1.44px',
          textAlign: 'left',
        },

        '& .section-header__subtitle': {
          color: palette.text.description,
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '26px',
          letterSpacing: '-0.8px',
          textAlign: 'left',
        },

        '& .primary-static-button': {
          height: 48,
          padding: '12px 20px',
          background: palette.primary.main,
          color: palette.primary.contrastText,
          borderRadius: '16px 0 16px 0',
          fontSize: 16,
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '-0.32px',
          boxShadow: 'none',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table': {
        borderColor: palette.background.tableBorder,

        '& .MuiTableCell-root': {
          borderColor: `${palette.background.tableBorder} !important`,
        },
      },
      '& .service-plan-table .savings-subheader': {
        backgroundColor: palette.background.main,
        color: `${palette.text.primary} !important`,
        fontWeight: 600,
      },
      '& .savings-contact-card': {
        backgroundColor: palette.background.greySubtler,
        padding: '0px !important',
      },
      '& .savings-header': {
        color: `${palette.text.primary} !important`,
      },
      '& .footer-bar': {
        background: palette.background.level1,
      },
      '& .view-more-button': {
        backgroundColor: palette.background.level1,
        color: palette.text.highlight,
      },
      '& .savings-topheader': {
        color: `${palette.text.highlight} !important`,
        fontWeight: '500 !important',
      },
    },

    /* Static Page Hero Banners */
    '& .find-provider-section, & .plan-selection-section, & .checkout-hero-section, & .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section, & .savings-hero-section, & .faq-hero-section':
      {
        background: palette.background.heroOther,
        color: `${palette.text.highlight} !important`,

        '& .hero-header-title, & .hero-header-subtitle': {
          color: `${palette.text.highlight} !important`,
        },
      },
    '& .book-appointment-hero-section': {
      height: '100%',
      backgroundColor: palette.background.main,

      '& .MuiTypography-root': {
        color: palette.text.primary,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
        },
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .home-static-hero-wrapper': {
        '& .hero-static-section': {
          '& .section-header__title, .section-header__subtitle': {
            color: palette.text.highlight,
          },
        },
        '& .hero-static-bg': {
          backgroundColor: palette.background.secondary,
        },
      },
      '& .plans-wrapper': {
        '& .highlight-button': {
          backgroundColor: palette.text.highlight,
        },
        '& .highlight-divider': {
          backgroundColor: palette.text.disabled,
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* FAQ - Styles */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        color: palette.text.primary,
        margin: '0 auto',
        textAlign: 'center',
      },
      '& .header-container': {
        justifyContent: 'center',
        margin: '0 auto',
      },
    },
    '& .faq-contact-wrapper': {
      background: palette.background.greySubtler,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },
  },

  /* Footer Disclosure */
  '& .footer-wrapper, & .footer-wrapper a': {
    backgroundColor: `${palette.background.footer} !important`,
    color: `${palette.text.highlight} !important` 
  },
};
